import React, { useMemo } from 'react';
import classnames from 'classnames';
import { Select, SelectProps } from 'tea-component';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';

import { SELECT_LIST_HEIGHT } from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';
import { getOptions } from '../utils';

import '../index.scss';

import type { IBaseProps, IGameType } from '@/pages/intelligence/types/common';

interface ISingleSourceSelectProps extends IBaseProps, SelectProps {
  entityType?: IGameType;
  isShowButtonLabel?: boolean;
  sources: string[];
}

const SingleSourceSelector: React.FC<ISingleSourceSelectProps> = (props) => {
  const {
    style,
    className,
    overlayStyle,
    overlayClassName,
    disabled,
    entityType = 'mobile',
    isShowButtonLabel = true,
    sources,
    value,
    onChange,
  } = props;

  const { locale, formatMessage } = useIntlExtend();

  const rankingText = formatMessage({ id: 'dbi_ranking' });

  const options = useMemo(() => getOptions(entityType, sources, formatMessage), [locale, sources]);

  const button = useMemo(() => {
    const option = options?.find((item) => item?.value === value);
    return (
      <div className="dbi-select-button">
        {isShowButtonLabel && <div className="dbi-select-button-text">{rankingText}</div>}
        <div className="dbi-select-flex">{option?.text}</div>
      </div>
    );
  }, [value, options, isShowButtonLabel, rankingText]);

  return (
    <Select
      style={style}
      className={classnames('dbi-single-source-select search-item', className)}
      overlayStyle={overlayStyle}
      overlayClassName={classnames('dbi-single-source-select-overlay', overlayClassName)}
      appearance="button"
      listHeight={SELECT_LIST_HEIGHT}
      disabled={disabled}
      matchButtonWidth={true}
      button={button}
      options={options}
      value={value}
      onChange={onChange}
    />
  );
};

export default SingleSourceSelector;
